/*
 *
 * MessagesHomePopups
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 20-Mar-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  readAndConfirm: <PortalMessage
    id='t.app.ttl.messages.readAndConfirm'
    defaultMessage='Leggi il messaggio e conferma'
                  />,
  confirm: <PortalMessage
    id='t.app.okUnderstood'
    defaultMessage='Ok, ho capito'
           />
}

export default formattedMessage
